import { render, staticRenderFns } from "./list-collection-progress-btn.vue?vue&type=template&id=6767a311&"
import script from "./list-collection-progress-btn.vue?vue&type=script&lang=js&"
export * from "./list-collection-progress-btn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports